import { render } from "./Profile.vue?vue&type=template&id=24b07a8f&scoped=true&ts=true"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"

import "./Profile.vue?vue&type=style&index=0&id=24b07a8f&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\330398ee0e098db7\\LoadingSokoldok\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b07a8f"]])

export default __exports__